import React, { useState } from "react";
import Draggable from "react-draggable";
import ChartProperties from "../index";
import TemplateChartProperties from "../../chartTemplates/index";

const DefaultPropertiesModal = ({ onCancel, handleUpdateDefaultProperty, exportPropertyId, type = "property" }) => {
    return (
        <React.Fragment>
            <div
                className="modal assign-init-modal image-pull-modal config-modal smart-recom"
                style={{ display: "block" }}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <Draggable handle=".default-property-modal" cancel=".non-draggable">
                    <div className="modal-dialog assignModal" role="document">
                        <div className="modal-content">
                            <div className="modal-header default-property-modal" style={{ cursor: "move" }}>
                                <button type="button" className="close non-draggable" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <form autoComplete="nope">
                                <div className="modal-body ">
                                    <div className="form-group">
                                        <div className="formInp">
                                            <div className="dashboard-outer">
                                                <div className="outer-detail">
                                                    <div className="right-panel-section">
                                                        <div className="dtl-sec">
                                                            <div className="dtl-sec system-building col-md-12 ">
                                                                <div className="tab-dtl region-mng">
                                                                    <div className="tab-active recomdn-table bg-grey-table modal-table-scroll">
                                                                        {type === "template" ? (
                                                                            <TemplateChartProperties isDefaultTemplatesView={true} />
                                                                        ) : (
                                                                            <ChartProperties
                                                                                isDefaultPropertiesView={true}
                                                                                exportPropertyId={exportPropertyId}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 p-0 text-right btnOtr">
                                            <button
                                                type="button"
                                                onClick={() => handleUpdateDefaultProperty()}
                                                className={`btn btn-primary btnRgion col-md-2 `}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Draggable>
            </div>
        </React.Fragment>
    );
};

export default DefaultPropertiesModal;
